export { default, FontDeclarations } from './FontPreload';
